export default __webpack_public_path__ + "static/media/NeueMachina-Regular.a78611e1.woff2";